import type { Thesis } from '../../types/thesis'
import { STATUS_COLORS } from '../../types/thesis'

interface ThesisCardProps {
  thesis: Thesis
  onEdit: (thesis: Thesis) => void
  onDelete: (thesis: Thesis) => void
  onSuggestRules: (thesis: Thesis) => void
}

export function ThesisCard({ thesis, onEdit, onDelete, onSuggestRules }: ThesisCardProps) {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-5 hover:shadow-md transition-shadow">
      <div className="flex justify-between items-start mb-3">
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-gray-900">{thesis.name}</h3>
          {thesis.target_allocation_pct !== null && thesis.target_allocation_pct !== undefined && (
            <span className="text-sm text-gray-500">
              Target: {thesis.target_allocation_pct}%
            </span>
          )}
        </div>
        <span
          className={`px-2 py-1 text-xs font-medium rounded-full ${STATUS_COLORS[thesis.status]}`}
        >
          {thesis.status}
        </span>
      </div>

      {thesis.narrative && (
        <p className="text-sm text-gray-600 mb-4 line-clamp-2">{thesis.narrative}</p>
      )}

      <div className="flex items-center gap-4 text-sm text-gray-500 mb-4">
        <div className="flex items-center gap-1">
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
            />
          </svg>
          <span>{thesis.rules_count ?? 0} rules</span>
        </div>
        <div className="flex items-center gap-1">
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
            />
          </svg>
          <span>{thesis.holdings_count ?? 0} holdings</span>
        </div>
      </div>

      <div className="flex gap-2 pt-3 border-t border-gray-100">
        <button
          onClick={() => onEdit(thesis)}
          className="flex-1 px-3 py-1.5 text-sm text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors"
        >
          Edit
        </button>
        <button
          onClick={() => onSuggestRules(thesis)}
          className="flex-1 px-3 py-1.5 text-sm text-primary-700 bg-primary-50 hover:bg-primary-100 rounded-md transition-colors"
        >
          AI Rules
        </button>
        <button
          onClick={() => onDelete(thesis)}
          className="px-3 py-1.5 text-sm text-red-600 hover:bg-red-50 rounded-md transition-colors"
        >
          Delete
        </button>
      </div>
    </div>
  )
}
